import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "auditChange";
let _lastChange = "";
let _currentUserActivity = [];
let _currentIntegrationActivity = [];
let _currentSystemActivity = [];
let _currentSystemNotes = [];
class AuditStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getUserActivity() {
    return _currentUserActivity;
  }
  getIntegrationActivity() {
    return _currentIntegrationActivity;
  }
  getSystemActivity() {
    return _currentSystemActivity;
  }
  getSystemNotes() {
    return _currentSystemNotes;
  }
  lastChange() {
    return _lastChange;
  }
}
const store = new AuditStore();
Dispatcher.register((action) => {
  _lastChange = action.actionType;
  switch (action.actionType) {
    // loading the full list of Companion schemas
    case actionTypes.AuditUserActivity:
      _currentUserActivity = action.Result;
      store.emitChange();
      break;
    case actionTypes.AuditIntegration:
      _currentIntegrationActivity = action.Result;
      store.emitChange();
      break;
    case actionTypes.AuditSystem:
      _currentSystemActivity = action.Result;
      store.emitChange();
      break;
    case actionTypes.AuditSysNote:
      _currentSystemNotes = action.Result;
      store.emitChange();
      break;
    default:
  }
});
export default store;
